import script from "./HdEducationInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./HdEducationInfo.vue?vue&type=script&setup=true&lang=js"

import "./HdEducationInfo.vue?vue&type=style&index=0&id=4c80a204&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c80a204"]])

export default __exports__